<template>
  <div class="login web-content">
    <div class="form-content">
      <div class="header">
        <img src="../../assets/staff/logo.png" />
        <span>销巴员工登陆</span>
      </div>
      <el-form label-position="top">
        <el-form-item label="手机号">
          <el-input placeholder="请输入您的手机号"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" class="code">
          <el-input placeholder="请输入短信验证码"></el-input>
          <el-button @click="getCode" :disabled="verifyStatus">{{verifyText}}</el-button>
        </el-form-item>
      </el-form>
      <el-row class="btn-submit">
        <el-button @click="login" type="danger">登录</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      verifyStatus: false,
      verifyText: "获取验证码"
    };
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    getCode() {
      this.verifyStatus = true;
      let time = 120;
      this.verifyText = time + "s";
      this.timer = setInterval(() => {
        if (time == 1) {
          this.verifyText = "重新获取";
          this.verifyStatus = false;
          clearInterval(this.timer);
          return;
        }
        this.verifyText = --time + "s";
      }, 1000);
    },
    login() {
      console.log("login");
      this.$router.push("/staff/pandect");
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 1200px;
  background-color: #fff;
  margin: auto;
  overflow: hidden;

  .form-content {
    margin: 52px auto 0;
    width: 417px;

    .header {
      color: #555555;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }

    /deep/ .el-form {
      margin-top: 40px;

      .el-form-item {
        margin-bottom: 24px;

        .el-form-item__label {
          font-size: 16px;
          color: #555555;
          padding: 0;
          height: 40px;

          .suffix {
            margin-left: 16px;

            .el-checkbox__label {
              padding-left: 8px;
            }
          }
        }
        .el-form-item__content {
          display: flex;
          .el-input {
            .el-input__inner {
              height: 55px;
            }
          }
        }
      }
    }

    .btn-submit {
      /deep/ .el-button {
        width: 100%;
        line-height: 36px;
        background-color: #e60616;

        span {
          font-size: 16px;
          font-weight: 500;
          display: inline-block;
          letter-spacing: 10px;
          text-indent: 10px;
        }
      }
    }

    .code {
      .el-button {
        font-size: 16px;
        height: 55px;
        flex: 0 0 122px;
        margin-left: 16px;

        &:not([disabled]) {
          color: #e60616;
          border: 1px solid #e60616;
        }
      }
    }
  }
}
</style>